import { render, staticRenderFns } from "./Jalert.vue?vue&type=template&id=5151eb28&scoped=true&"
import script from "./Jalert.vue?vue&type=script&lang=js&"
export * from "./Jalert.vue?vue&type=script&lang=js&"
import style0 from "./Jalert.vue?vue&type=style&index=0&id=5151eb28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5151eb28",
  null
  
)

export default component.exports